// 引入mux.js
const muxjs = require('mux.js');

// 指定 MP4 文件的 URL
// const mp4Url = 'https://resource.3uplay.com/gift/voice-room/cocktail.mp4';
// const mp4Url = 'https://resource.funplus.social/sys-feed/vip10mount.mp4';
export function getVapConfig(src) {
  // 使用 Fetch API 发起请求获取 MP4 数据
  return new Promise((resolve, reject) => {
    fetch(src)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.arrayBuffer(); // 将响应转换为 ArrayBuffer
      })
      .then(mp4Data => {
        // 使用 Uint8Array 处理 ArrayBuffer 数据
        const uint8Array = new Uint8Array(mp4Data);
        var parsed = muxjs.mp4.tools.inspect(uint8Array);
        //获取vapc的config配置
        const vapcData = parsed.find(item => item.type == 'vapc');
        // 使用 TextDecoder 解码 Uint8Array 为字符串
        const textDecoder = new TextDecoder('utf-8');
        const jsonString = textDecoder.decode(vapcData.data);
        // 解析 JSON 字符串为 JSON 对象
        const jsonObject = JSON.parse(jsonString);
        // 输出 JSON 对象
        resolve(jsonObject);
      })
      .catch(error => {
        reject(error);
        console.error('Fetch error:', error);
      });
  });
}
